
























































































































import Vue from 'vue'
import Component from 'vue-class-component'
import { EResidentStatus, EUserPermissions, IResidentContact } from '@zunta/configurations'
import { getModule } from 'vuex-module-decorators'
import { ResidentModule } from '@/store/modules/resident.module'
import Icon from '@/components/Icon.vue'
import Api from '@/api'
import { User } from '@/classes/User'

import Switcher from '@/components/Switcher.vue'

@Component({
  props: {
    contact: {
      type: Object,
      require: true
    },
    residentId: {
      type: [String, Number],
      require: true
    },
    resident: {
      type: Object,
      default: null
    },
    opened: {
      type: Boolean,
      default: false
    },
    disableToggle: {
      type: Boolean,
      default: false
    }
  },
  components: {
    Switcher,
    Icon
  }
})

export default class ResidentContact extends Vue {
  residentModuleInstance: ResidentModule = getModule(ResidentModule, this.$store)
  EUserPermissions: any = EUserPermissions
  EResidentStatus: any = EResidentStatus
  user: User = Api.getUser() as User

  isVisible: boolean = this.$props.opened

  isAnyFieldOfAddress (contact: IResidentContact) {
    return contact.city ||
      contact.state ||
      contact.zipCode ||
      contact.addressLine2 ||
      contact.addressLine1 ||
      contact.addressLine3
  }

  checkPermissions () {
    if (!this.user.hasPermissionFor(EUserPermissions.EDIT_CONTACT_SETTINGS) && !this.user.isResident()) {
      this.$eventBus.$emit('notify', {
        color: 'var(--status-error-color)',
        message: 'Permission Denied',
        header: `Modify Contact Settings`,
        icon: 'warning'
      })
      return false
    }
    return true
  }

  toggleVisible () {
    this.isVisible = !this.isVisible
    this.$emit('toggleDetails', this.isVisible)
  }

  async toggleDeliverToRoom (value: any) {
    if (!this.checkPermissions()) {
      return
    }
    await this.residentModuleInstance.updateResidentSettings({
      residentId: this.$props.resident.id,
      settings: {
        deliverToRoom: value
      }
    })
    this.$emit('deliverToRoomUpdate')
  }

  async toggleResidentContactAddressForMailing (contact: IResidentContact, value: boolean) {
    if (this.checkPermissions()) {
      await this.residentModuleInstance.toggleResidentContactAddressForMailing({
        residentId: this.$props.residentId,
        contactId: contact.id,
        isAddressUsedForMailing: value
      })
      contact.isAddressUsedForMailing = value
      this.$emit('makemailing', contact.id)
    }
  }

  async toggleResidentContactEmailForMailing (contact: IResidentContact, value: boolean) {
    if (this.checkPermissions()) {
      await this.residentModuleInstance.toggleResidentContactEmailForMailing({
        residentId: this.$props.residentId,
        contactId: contact.id,
        isEmailUsedForMailing: value
      })
      contact.isEmailUsedForMailing = value
      this.$emit('makemailing', contact.id)
    }
  }

  get isAddressValid () {
    return this.$props.contact.zipCode && /^\d{5}(?:[-\s]\d{4})?$/.test(this.$props.contact.zipCode) &&
      this.$props.contact.state &&
      this.$props.contact.city &&
      this.$props.contact.addressLine1
  }

  get isEmailValid () {
    return this.$props.contact && /([a-zA-Z0-9._-]+@[a-zA-Z0-9._-]+\.[a-zA-Z0-9_-]+)/i.test(this.$props.contact.email)
  }

  get mailAddressString () {
    const contact = this.$props.contact
    if (!contact) {
      return ''
    }
    let addressLine = ''
    if (contact.addressLine1) {
      addressLine = contact.addressLine1
    }
    if (contact.addressLine2) {
      addressLine = addressLine + ' ' + contact.addressLine2
    }
    if (contact.addressLine3) {
      addressLine = addressLine + ' ' + contact.addressLine3
    }
    if (contact.city) {
      addressLine = addressLine + ' ' + contact.city
    }
    // @ts-ignore
    if (contact.state && contact.state !== '-1') {
      addressLine = addressLine + ', ' + contact.state
    }
    if (contact.zipCode) {
      addressLine = addressLine + ' ' + contact.zipCode
    }
    return addressLine
  }

  get tooltip () {
    return (contact: any) => {
      if (contact.typesOfContact && contact.typesOfContact.length) {
        let text = '<ul class="tooltip-list">'
        contact.typesOfContact.forEach((payer: any) => {
          text += `<li class="tooltip-item">• ${payer}</li>`
        })
        text += '</ul>'
        return text
      }
      return ''
    }
  }
}
